import { Link } from '@remix-run/react';

import Typography from '~/components/Typography';
import type { WebThemeV2 } from '~/interfaces/publication';
import getNormalizedCategory from '~/utils/getNormalizedCategory';

import NavGroupPopover from './NavGroupPopover';

interface Props {
  children: React.ReactNode;
  subLinks: any;
  webTemplate: any;
  theme: WebThemeV2;
}

const CategoriesPopover = ({ children, subLinks, webTemplate, theme }: Props) => {
  const isCustomCategoriesEnabled = webTemplate.enable_customize_category_ids;
  const categoryIds = webTemplate.category_ids;

  return (
    <NavGroupPopover
      theme={theme}
      popoverContent={
        // biome-ignore lint/complexity/noUselessFragments: Otherwise it will error because of the ternary
        <>
          {subLinks.map((sublink: any) => {
            if (isCustomCategoriesEnabled && !categoryIds.includes(sublink.id)) {
              return null;
            }

            return (
              <Link
                key={sublink.id}
                className="flex rounded-wt px-3 py-2.5 hover:bg-black/5"
                to={`/t/${getNormalizedCategory(sublink.display)}`}
              >
                <Typography
                  as="span"
                  color={theme.navbar_text_color}
                  fontFamilyv2={theme.navbar_font_family}
                  className="text-xs sm:block"
                >
                  {sublink.display}
                </Typography>
              </Link>
            );
          })}
        </>
      }
    >
      {children}
    </NavGroupPopover>
  );
};

export default CategoriesPopover;
